import { load as sharedLoad } from '@server/groupLoad';

export const load = sharedLoad;
